import LevelBase from "./levelBase";
import { Enemy, Exit } from "../objects";
import { Interactive } from "../objects";
import { translate } from "../../utils/localization";
import {
  PIXEL_NAME,
  PIXEL_TO_TILEMAP_POSITION,
  SCALE,
} from "../../utils/constants";
import UI from "../UI";

class Level3 extends LevelBase {
  constructor() {
    super();
    this.name = "The tower";
    this.diamondsGoal = 0;
  }

  get id() {
    return this.constructor.key;
  }

  async connectToScene(scene) {
    await super.connectToScene(scene)

    let light_beam = this.scene.add.image(
      this.scene.cameras.main.width / 2,
      this.scene.cameras.main.height / 2,
      "light_beam"
    );
    light_beam.x = UI.tileToScreen(20.5);
    light_beam.y = UI.tileToScreen(10);
    light_beam.setOrigin(0, 0);
    light_beam.setScale(SCALE * 2);
    light_beam.scaleX = SCALE;
    light_beam.setScrollFactor(1);
    light_beam.depth = 4.5;
    light_beam.alpha = 0.5;

    let particles = scene.add.particles("spark").setScale(SCALE);
    let emitter = particles.createEmitter();
    emitter.setPosition(
      { min: UI.tileToPixels(21), max: UI.tileToPixels(26) },
      { min: UI.tileToPixels(9), max: UI.tileToPixels(24) }
    );
    emitter.setQuantity(5);
    emitter.setFrequency(20000);
    emitter.setAngle({ min: 0, max: 360 });
    emitter.setSpeed(5);
    emitter.setGravityY(0.1);
    emitter.setGravityX(0);
    emitter.setLifespan({ min: 10000, max: 50000 });
    emitter.alpha.onChange(0.5);

    // beam 2
    light_beam = this.scene.add.image(
      this.scene.cameras.main.width / 2,
      this.scene.cameras.main.height / 2,
      "light_beam"
    );
    light_beam.x = UI.tileToScreen(12.5);
    light_beam.y = UI.tileToScreen(31);
    light_beam.setOrigin(0, 0);
    light_beam.setScale(SCALE * 2);
    light_beam.scaleX = SCALE * 2.25;
    light_beam.setScrollFactor(1);
    light_beam.depth = 4.5;
    light_beam.alpha = 0.5;

    particles = scene.add.particles("spark").setScale(SCALE);
    emitter = particles.createEmitter();
    emitter.setPosition(
      { min: UI.tileToPixels(15), max: UI.tileToPixels(26) },
      { min: UI.tileToPixels(29), max: UI.tileToPixels(44) }
    );
    emitter.setQuantity(5);
    emitter.setFrequency(20000);
    emitter.setAngle({ min: 0, max: 360 });
    emitter.setSpeed(5);
    emitter.setGravityY(0.1);
    emitter.setGravityX(0);
    emitter.setLifespan({ min: 10000, max: 50000 });
    emitter.alpha.onChange(0.5);
  }

  onInteractWith(el) {
    super.onInteractWith(el);
    if (el.isClass(Exit)) {
      this.onComplete();
    }
    if (el.isClass(Interactive) && [1, 2].includes(el.order) && this.unfinished) {
      this.showDialog1()
      // ================================
      // removes usless interactive spots
      // ================================
      Object.keys(this.interactiveElements).forEach((k) => {
        // removes if is not the exit
        const spot = this.interactiveElements[k]
        if (spot && !spot.isClass(Exit) && spot.order <= 2) {
          this.interactiveElements[k] = null;
        }
      });
    }
    if (el.isClass(Interactive) && el.order === 3) {
      const layer = this.scene.children.getByName("layer_1");
      const { tilemap: map } = layer;
      this.player.power = 1;
      this.player.hasPickaxe = true;
      map.putTileAt(
        PIXEL_TO_TILEMAP_POSITION[PIXEL_NAME.EMPTY],
        el.position.x,
        el.position.y,
        false,
        "layer_1"
      );
      el.alien.destroy();

      if(this.unfinished) {
        this.showDialog4();
      }
    }
  }

  showDialog1() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ['Mary'],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_3.dialog_1.mary_say_1")],
          options: [],
        },
      ],
    });
  }
  
  showDialog4() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ['Mary'],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_3.dialog_4.mary_say_1")],
        },
      ],
    });
  }

  onAddElement(el) {

    // add pickaxe
    if (el.isClass(Interactive) && el.order === 3) {
      const layer = this.scene.children.getByName("layer_1");
      const { tilemap: map } = layer;
      const pickaxe = this.scene.add
        .sprite(48, 16)
        .setOrigin(0, 0.25)
        .play("pickaxe_idle");
      pickaxe.setScale(layer.scaleX);
      pickaxe.x = map.tileToWorldX(el.position.x);
      pickaxe.y = map.tileToWorldY(el.position.y);

      el.alien = pickaxe;
    }


    if (el.isClass(Enemy)) {
      // make second enemy to run ACW so boulder can make it escape from blast
      if (this.enemiesCount === 1) {
        el.scanDirection = "ACW";
      }
    }

  }
  
}

Level3.key = 'level_3'
export default Level3;
